import { render, staticRenderFns } from "./chat-on-receipts.vue?vue&type=template&id=ce7ad33e&scoped=true"
import script from "./chat-on-receipts.vue?vue&type=script&lang=js"
export * from "./chat-on-receipts.vue?vue&type=script&lang=js"
import style0 from "./chat-on-receipts.vue?vue&type=style&index=0&id=ce7ad33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7ad33e",
  null
  
)

export default component.exports